import React, { useContext, useEffect, useState } from "react"
import { GetApi } from "../../../../api/api"
import { FeatureCatalogContext } from "../../FeatureCatalogProvider"
import featureTypeIcon from "../../Assets/Icons/featureType.svg"
import attributeTypeIcon from "../../Assets/Icons/attributeType.svg"
import Searchbar from "./Searchbar"
import "./search.scss"
import { TypeCategories } from "../../../../api/generated/QuadriConfigurationApi"
import { useHistory, useParams } from "react-router-dom"
import useQuery from "../UseQuery"

interface ITypes {
  name: string
  pid: number
  category: TypeCategories
}

let timeout: any

const Search = () => {
  const [types, setTypes] = useState(new Array<ITypes>())
  const [searchKey, setSearchKey] = useState("")
  const context = useContext(FeatureCatalogContext)
  const history = useHistory()
  const { catalog } = useParams<{ catalog: string; type: string; pid: string }>()
  const [isLoading, setIsLoading] = useState(false)
  const language = useQuery().get("language")
  
  useEffect(() => {
    const getSearchReults = async () => {
      if (searchKey === "") {
        setTypes([])
        return
      }
      if (typeof timeout !== "undefined") {
        clearTimeout(timeout)
      }
      // legg til spinner
      setIsLoading(true)
      timeout = setTimeout(
        () =>
          GetApi().then((api) => {
            api.searchForTypes(catalog, searchKey, undefined, undefined, undefined, language).then(async (response) => {
              const result = new Array<ITypes>()
              response.items.map((item) => {
                result.push({
                  name: item.name,
                  pid: item.id,
                  category: item.category
                })
              })
              setTypes(result)
              setIsLoading(false)
            })
          }),
        300
      )
    }

    getSearchReults()
  }, [searchKey, language])

  const handleChange = (event: any) => {
    setSearchKey(event.target.value)
  }

  return (
    <div>
      <Searchbar handleChange={handleChange} value={searchKey} />
      <div className="results">
        <ul className="list-group list-group-borderless list-group-condensed bg-white">
          {isLoading ? (
            <li className="spinnerItem">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </li>
          ) : null}
          {types.map((type) => {
            if (searchKey === "") {
              setTypes([])
              return null
            }
            const onClick = () => {
              setSearchKey("")
              setTypes([])
              context.setTypeDisplayName(type.name)
              if (type.category === TypeCategories.FeatureType) {
                context.setAtId(null)
                context.updateHistory(history, catalog, "featureType", "" + type.pid)
              } else {
                context.setAtId(type.pid)
                context.updateHistory(history, catalog, "attributeType", "" + type.pid)
              }
            }
            return (
              <li
                onClick={onClick}
                className="list-group-item card-text-2"
                id="listItems"
                key={type.category + type.pid}
              >
                <div className="pr-3">
                  {type.category === TypeCategories.FeatureType ? (
                    <img src={featureTypeIcon} />
                  ) : (
                    <img src={attributeTypeIcon} />
                  )}
                  <span className="nameString">{type.name} </span>
                  <span className="badge badge-sm badge-text-secondary">{type.pid}</span>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default Search
